import { useEffect, useRef } from 'react';
import { app } from './bridge';

/**
 * 首屏就绪时通知原生收起骨架屏。
 *
 * 原生 WebView 的骨架屏在 `app.ready()` 之前一直显示（最多 3s 兜底）。
 * 所以**要等首屏数据到位（或已展示错误）**再调，否则会早早撤掉骨架、
 * 露出中间态。成功态和错误态都要调。
 */
export function useAppReady(ready: boolean): void {
  const sent = useRef(false);
  useEffect(() => {
    if (sent.current || !ready) return;
    sent.current = true;
    void app.ready();
  }, [ready]);
}
